/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PromisableAction } from "models/promisable-action";

export interface ForgotPasswordRequest extends PromisableAction {
    cpf: string;
}

interface State {
    isRequesting: boolean;
    errors: string[];
}

const initialState: State = {
    isRequesting: false,
    errors: [],
};

const forgotPasswordSlice = createSlice({
    name: "users@forgotPassword",
    initialState,
    reducers: {
        forgotPasswordRequest: (state, action: PayloadAction<ForgotPasswordRequest>): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        forgotPasswordSuccess: (state): void => {
            state.isRequesting = false;
        },
        forgotPasswordFailed: (state, action: PayloadAction<string[]>): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        },
    },
});

export const { forgotPasswordFailed, forgotPasswordRequest, forgotPasswordSuccess } =
    forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
